<template>
    
    <div v-if="!$route.params.school" class="slid-cat">
      <img src="@/assets/pic-test.jpg">
    </div>
    <div v-else class="slid-cat">
        <img v-if="$route.params.school == 'ali-ibn-musa'" src="@/assets/madares-bg/ali-ibn-musa.jpg" alt="background">
        <img v-if="$route.params.school == 'karimeh'" src="@/assets/madares-bg/karimeh.jpg" alt="background">
        <img v-if="$route.params.school == 'sadr'" src="@/assets/madares-bg/sadr.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-kazem'" src="@/assets/madares-bg/imam-kazem.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-javad'" src="@/assets/madares-bg/imam-javad.jpg" alt="background">
        <img v-if="$route.params.school == 'imam-sadeq'" src="@/assets/madares-bg/imam-sadeq.jpg" alt="background">
        <img v-if="$route.params.school == 'women-qom'" src="@/assets/madares-bg/women-qom.jpg" alt="background">
        <img v-if="$route.params.school == 'women-tehran'" src="@/assets/madares-bg/women-tehran.jpg" alt="background">
        <img v-if="$route.params.school == 'markaz-tehran'" src="@/assets/madares-bg/markaz-tehran.jpg" alt="background">
        <img v-if="$route.params.school == 'markaz-qom'" src="@/assets/madares-bg/markaz-qom.jpg" alt="background">
    </div>
    <div class="diwider-tape">
        <div class="brown-tape"></div>
        <div class="gray-tape"></div>
        <div class="green-tape"></div>
    </div>


    <div class="news-box">
        <span class="title">{{ !$route.name.match(/^gallery/ig) ? (!$route.params.query ? (t('news.archive') + (!($route.params.topic || $route.params.school) ? '' : (' ' + translatedTopic))) : `${t('news.results')} «${$route.params.query}»`) : t('visitNews.gallery') }}</span>
        <router-link :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/new`" class="btn btn-brown" style="margin-top: -1rem; margin-right: 3vw;" v-if="(auth ? auth.news.create : false) && !$route.params.query">{{ t('news.newNews') }}</router-link>
        <div class="news">
            <NewsCard type="post-1" v-for="(thisNew, i) in news" :key="i" :the-new="thisNew" />
        </div>
        <button class="btn btn-green" @click="fetchNews(++page)" v-if="showMoreButton" style="margin-bottom: 25px;">{{ t('news.more') }}</button>
    </div>



</template>

<script setup>

import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuth } from '@/authentication'
import $ from 'jquery'
import { useI18n } from 'vue-i18n'
import NewsCard from '@/components/NewsCard'

const $router = useRouter();
const $route = useRoute();

const auth = useAuth();

const { locale, t } = useI18n();

if ($route.params.locale) locale.value = $route.params.locale

const news = ref([]);

const page = ref(1);

const showMoreButton = ref(true);

const VUE_APP_SERVER_ROOT = process.env.VUE_APP_SERVER_ROOT

const translatedTopic = ref("")

function fetchNews() {
    if ($route.name.match(/^gallery/ig)) $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/gallery/${page.value}`,
        method: 'GET',
        dataType: 'json',
        xhrFields: { withCredentials: true },
        success(data) {
            if (!data.STATUS) {
                if (data.REASON == 'صفحه شماره 1 وجود ندارد.') {
                    alert("جستجو نتیجه ای نداشت")
                } else {
                    console.error(data.REASON)
                }
                showMoreButton.value = false
            } else {
                for(const _new of data.RESULT) {
                    _new.createdDate = (new Date(_new.created_datetime)).toLocaleDateString("fa-IR");
                    _new.createdTime = (new Date(_new.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':');
                    _new.vin = !!Number(_new.vin)
                    news.value[news.value.length] = _new;
                }

                if (data.LAST_PAGE) showMoreButton.value = false;
            }
        },
        error() {
            alert('اتصال به سرور ممکن نیست')
        }
    })
    else if (!$route.params.topic && !$route.params.school) $.ajax({
        url: !$route.params.query ? `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/news/${page.value}` : `${process.env.VUE_APP_SERVER_ROOT}search/${page.value}/${$route.params.query}`,
        method: "GET",
        dataType: "json",
        xhrFields: {
            withCredentials: true,
        },
        success(data) {
            if (!data.STATUS) {
                if (data.REASON == 'صفحه شماره 1 وجود ندارد.') {
                    alert("جستجو نتیجه ای نداشت")
                } else {
                    console.error(data.REASON)
                }
                showMoreButton.value = false
            } else {
                for(const _new of data.RESULT) {
                    _new.createdDate = (new Date(_new.created_datetime)).toLocaleDateString("fa-IR");
                    _new.createdTime = (new Date(_new.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':');
                    _new.vin = !!Number(_new.vin)
                    news.value[news.value.length] = _new;
                }

                if (data.LAST_PAGE) showMoreButton.value = false;
            }
        },
        error() {
            alert("اتصال به سرور ممکن نیست")
        }
    }); else if ($route.params.topic && ["public", "ali_ibn_musa", "karimeh", "sadr", "imam_javad", "imam_kazem", "imam_sadeq", "center_qom", "center_tehran", "women_tehran", "women_qom", "international", "students", "schools", "edu"].map(n => n == $route.params.topic).length) $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/news/${$route.params.topic}/${page.value}`,
        method: "GET",
        dataType: "json",
        xhrFields: { withCredentials: true },
        success(data) {
            if (!data.STATUS) {
                if (data.REASON == 'صفحه شماره 1 وجود ندارد.') {
                    alert("خبری در این دسته یافت نشد")
                } else {
                    alert(data.REASON)
                }
                showMoreButton.value = false
            } else {
                for(const _new of data.RESULT) {
                    _new.createdDate = (new Date(_new.created_datetime)).toLocaleDateString("fa-IR");
                    _new.createdTime = (new Date(_new.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':');
                    _new.vin = !!Number(_new.vin)
                    news.value[news.value.length] = _new;
                }

                if (data.LAST_PAGE) showMoreButton.value = false;

                switch($route.params.topic) {
                    case "public":
                        translatedTopic.value = ""
                        break;
                    case "ali_ibn_musa":
                        translatedTopic.value = "مدرسه علی‌ابن‌موسی‌الرضا علیهماالسلام"
                        break;
                    case "karimeh":
                        translatedTopic.value = "مدرسه کریمه"
                        break;
                    case "sadr":
                        translatedTopic.value = "مدرسه صدر بازار"
                        break;
                    case "imam_javad":
                        translatedTopic.value = "مدرسه امام‌جواد علیه‌السلام"
                        break;
                    case "imam_kazem":
                        translatedTopic.value = "مدرسه امام‌کاظم علیه‌السلام"
                        break;
                    case "imam_sadeq":
                        translatedTopic.value = "مدرسه امام‌صادق علیه‌السلام"
                        break;
                    case "center_qom":
                        translatedTopic.value = "مرکز تخصصی - شعبه قم"
                        break;
                    case "center_tehran":
                        translatedTopic.value = "مرکز تخصصی - شعبه تهران"
                        break;
                    case "women_tehran":
                        translatedTopic.value = "مدرسه مشکات اندیشه خواهران - شعبه تهران"
                        break;
                    case "women_qom":
                        translatedTopic.value = "مدرسه مشکات اندیشه خواهران - شعبه قم"
                        break;
                    case "international":
                        translatedTopic.value = "بین‌الملل"
                        break;
                    case "students":
                        translatedTopic.value = "مشکاتی‌ها"
                        break;
                    case "schools":
                        translatedTopic.value = "مدارس مشکات"
                        break;
                    case "edu":
                        translatedTopic.value = "آموزش و پژوهش"
                        break;
                }
            }
        }
    }); else if ($route.params.school && ["public", "ali-ibn-musa", "karimeh", "sadr", "imam-javad", "imam-kazem", "imam-sadeq", "center-qom", "center-tehran", "women-tehran", "women-qom"].map(n => n == $route.params.school).length) $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/news/${$route.params.school.replaceAll('-','_')}/${page.value}`,
        method: "GET",
        dataType: "json",
        xhrFields: { withCredentials: true },
        success(data) {
            if (!data.STATUS) {
                if (data.REASON == 'صفحه شماره 1 وجود ندارد.') {
                    alert("خبری در این دسته یافت نشد")
                } else {
                    alert(data.REASON)
                }
                showMoreButton.value = false
            } else {
                for(const _new of data.RESULT) {
                    _new.createdDate = (new Date(_new.created_datetime)).toLocaleDateString("fa-IR");
                    _new.createdTime = (new Date(_new.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':');
                    _new.vin = !!Number(_new.vin)
                    news.value[news.value.length] = _new;
                }

                if (data.LAST_PAGE) showMoreButton.value = false;

                switch($route.params.school) {
                    case "ali-ibn-musa":
                        translatedTopic.value = "مدرسه علی‌ابن‌موسی‌الرضا علیهماالسلام"
                        break;
                    case "karimeh":
                        translatedTopic.value = "مدرسه کریمه"
                        break;
                    case "sadr":
                        translatedTopic.value = "مدرسه صدر بازار"
                        break;
                    case "imam-javad":
                        translatedTopic.value = "مدرسه امام‌جواد علیه‌السلام"
                        break;
                    case "imam-kazem":
                        translatedTopic.value = "مدرسه امام‌کاظم علیه‌السلام"
                        break;
                    case "imam-sadeq":
                        translatedTopic.value = "مدرسه امام‌صادق علیه‌السلام"
                        break;
                    case "center-qom":
                        translatedTopic.value = "مرکز تخصصی - شعبه قم"
                        break;
                    case "center-tehran":
                        translatedTopic.value = "مرکز تخصصی - شعبه تهران"
                        break;
                    case "women-tehran":
                        translatedTopic.value = "مدرسه مشکات اندیشه خواهران - شعبه تهران"
                        break;
                    case "women-qom":
                        translatedTopic.value = "مدرسه مشکات اندیشه خواهران - شعبه قم"
                        break;
                }
            }
        }
    })
}

onMounted(fetchNews)

function redirectTo(id, main_headline) {
    $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + '/visit/' + id + '/' + main_headline);
}

watch(() => $route.name, () => {
    news.value = [];
    showMoreButton.value = true;
    page.value = 1;
    fetchNews();
})

</script>

<style scoped lang="less">

    @bright: #F4FFFF;
    @azure: #F0FEFF;
    @lighter-nonphotoblue: #ACE6EF;
    @darker-nonphotoblue: #7CD0DE;
    @moonstone: #4BBACD;
    @teal: #2D7B88;
    @lighter-midnightgreen: #12535F;
    @darker-midnightgreen: #09353E;
    @rich-black: #00171D;

    .c-bright                   { color: @bright; }
    .c-azure                    { color: @azure; }
    .c-lighter-nonphotoblue     { color: @lighter-nonphotoblue; }
    .c-darker-nonphotoblue      { color: @lighter-nonphotoblue; }
    .c-moonstone                { color: @moonstone; }
    .c-teal                     { color: @teal; }
    .c-lighter-midnightgreen    { color: @lighter-midnightgreen; }
    .c-darker-midnightgreen     { color: @darker-midnightgreen; }
    .c-rich-black               { color: @rich-black; }

    .br { border-radius: 10px; }
    .br-tr { border-top-right-radius: 10px; }
    .br-tl { border-top-left-radius: 10px; }
    .br-br { border-bottom-right-radius: 10px; }
    .br-bl { border-bottom-left-radius: 10px; }

    .new {
        margin-bottom: 2rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: stretch;
        height: fit-content;
        width: 80vw;
        margin: 2rem 10vw;
        cursor: pointer;
        transition: background .3s ease-in-out, box-shadow .3s ease-in-out;
        .br();

        &:hover {
            background-color: @azure;
            box-shadow: 0 3px 10px #0003;
        }

        h3 {
            .c-teal();
            padding: .7vw 1vw 0 .7vw!important;
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-start;
        }

        h4 {
            .c-moonstone();
            padding: 0 1vw;
        }

        .gray {
            color: gray;
            font-size: 1rem;
            margin: .7rem 1.8rem -.5rem 0;
        }

        .right {
            height: 180px;
            width: 180px;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            .br();

            @media only screen and (max-width: 768px) {
                display: none;
            }

            .new-img {
                height: auto;
                min-height: 100%;
                .br();
                min-width: 100%;
                width: auto;
            }
        }        
    }

    .btn-fetch-more {
        .c-teal();
        float: left;
        margin-left: 10vw;
        background: none;
        border: none;
        font-weight: bolder;
        outline: none!important;
        transition: background .3s ease-in-out, box-shadow .3s ease-in-out;
        border-radius: 10px;
        padding: .65rem .95rem;

        &:hover {
            background-color: @azure;
            box-shadow: 0 2px 5px #0003;
        }
    }
</style>